import { InjectionToken, ViewContainerRef } from '@angular/core';

export const ERROR_CONTAINER = new InjectionToken<ViewContainerRef>('error_container');
